import {atom } from "recoil";
import { AppAtomKeys } from "../ConstantKeys";

export type SpinnerOverlayAtomType={
    displaySpinner :boolean,
    displayOverlay : boolean,
}

export const spinnerOverlayDefaultValue ={
    displaySpinner : false,
    displayOverlay : false,
}

export const spinnerOverlayAtom=atom<SpinnerOverlayAtomType>({
    key : AppAtomKeys.spinnerOverlayAtom,
    default : spinnerOverlayDefaultValue
})

export const commonPageAtom = atom<boolean>({
    key : AppAtomKeys.commonPageAtom,
    default:true,
})